import * as React from "react";
import {useEffect, useRef, useMemo} from "react";
import {Trans, useTranslation} from "react-i18next";
import window from "../../../lib/WindowExtended";
import {IIsVisible} from "../../Checkout";
import {useCheckoutContext} from "../../CheckoutContextProvider/CheckoutContextProvider";
import "./Finished.scss";
import {ShippingSteps} from "../../../swipers/shippingSteps";

interface IFinishedBoughtItems {
  hasVoucher: boolean;
  hasItems: boolean;
}

const Finished: React.FC<IIsVisible> = (props) => {
  const {t} = useTranslation("checkout");
  const {checkout} = useCheckoutContext();
  const shippingSteps = useRef<HTMLDivElement>(null);
  const orderNumber = checkout.orderId;
  const purchase = useMemo<IFinishedBoughtItems>(() => {
    return {
      hasItems:
        checkout.cartData.positions.find((position) => {
          return position.type === "Item" && position.item?.itemClassId !== 6;
        }) !== undefined,
      hasVoucher:
        checkout.cartData.positions.find((position) => {
          return position.type === "Item" && position.item?.itemClassId === 6;
        }) !== undefined,
    };
  }, []);

  useEffect(() => {
    if (props.isVisible) {
      window.amazonPayAuthorized = window.isBillingAgreementAddressSet = window.isBillingAgreementPaymentSet = false;
      window.orderReferenceId = "";
      if (shippingSteps.current) {
        new ShippingSteps(shippingSteps.current);
      }
    }
  }, [props.isVisible]);

  if (!props.isVisible) {
    return null;
  }

  const ThankYou: React.FC = () => {
    const {invoiceAddress} = checkout;

    if (!invoiceAddress) {
      return null;
    }

    const customerName = `${invoiceAddress.firstName} ${invoiceAddress.lastName}`;

    return <h1>{t("Vielen Dank, {{customerName}}!", {customerName})}</h1>;
  };

  const WhatsNextSlider: React.FC = () => {
    if (!purchase.hasItems) {
      return null;
    }

    return (
      <div className="shippingsteps-gallery">
        <div ref={shippingSteps} className="swiper-container swiper-container-shippingsteps">
          <div className="swiper-wrapper">
            <div className="swiper-slide">
              <p>{t("Sie erhalten in Kürze eine E-Mail, die ...")}</p>
            </div>
            <div className="swiper-slide">
              <p>{t("Sobald Ihre Ware auf dem Weg zu Ihnen ist, erhalten Sie eine Versandbestätigung.")}</p>
            </div>
            <div className="swiper-slide">
              <p>{t("Verfolgen Sie den Status Ihrer Sendung – mit dem Tracking-Code aus Ihrer Versandbestätigung.")}</p>
            </div>
            <div className="swiper-slide">
              <p>{t("Wir möchten, dass Sie mit Ihren Einkäufen ...")}</p>
            </div>
          </div>
          <div className="swiper-pagination">{/* empty tag */}</div>
        </div>
      </div>
    );
  };

  const AdditionalVoucherInformation: React.FC = () => {
    const infos: string[] = [];

    if (!purchase.hasVoucher) {
      return null;
    }

    infos.push(t("Ihren Geschenkgutschein erhalten Sie unmittelbar nach Zahlungseingang als PDF via E-Mail."));

    if (purchase.hasItems) {
      infos.push(
        " ",
        t(
          "Beim Kauf gemeinsam mit anderen Artikeln kann sich der Versand des Gutscheins bis zum nächsten Werktag verzögern.",
        ),
      );
    }

    return (
      <React.Fragment>
        <br className="clear" />
        <div className="center">
          <span className="svg svg-single-icon-mail">&#160;</span>
        </div>

        <p>
          {infos.map((text) => {
            return text;
          })}
        </p>
      </React.Fragment>
    );
  };

  return (
    <div className={"text"}>
      <div className="reduced-width">
        <ThankYou />
        <p>
          <strong>{t("Ihre Bestellung war erfolgreich.")}</strong>
        </p>

        <p>
          <span className="svg svg-icon-check left" style={{marginBottom: "20px"}}>
            &#160;
          </span>
          {checkout.isGuest ? (
            t("Ihre Bestellnummer lautet {{orderNumber}}.", {orderNumber})
          ) : (
            <span>
              <Trans i18nKey={"bestellAbschlussMitNummer"} values={{orderNumber}} ns="checkout">
                Ihre Bestellung finden Sie unter der Nummer <b>{{orderNumber}}</b> in Ihrem{" "}
                <a href={t("userAccountLink")} target="_blank" rel="noreferrer">
                  Kundenkonto
                </a>{" "}
                wieder.
              </Trans>
            </span>
          )}
        </p>

        <br className="clear" />

        <p>
          <strong>{t("So geht es weiter")}</strong>
        </p>

        <WhatsNextSlider />
        <AdditionalVoucherInformation />

        {/* Sovendus-Container (zugehöriges JS wird im GTM eingebunden) */}
        <div>
          <div id="sovendus-container-1">{/* Empty */}</div>
          {/* TODO GTM greift nicht, weil es dynamisch reingeladen wird*/}
        </div>
      </div>
    </div>
  );
};

export default Finished;
